import react, { useState, useEffect } from 'react';
import { supabase } from '../supabaseclient';

export default function Equipe() {
  const [membros, setmembros] = useState([]);
  const [loading, setloading] = useState(false);

  // 1. busca todos os perfis cadastrados no sistema
  useEffect(() => {
    carregarequipe();
  }, []);

  const carregarequipe = async () => {
    const { data, error } = await supabase
      .from('perfis')
      .select('*')
      .order('nome', { ascending: true });
    
    if (!error) setmembros(data);
  };

  // 2. função para cadastrar novo usuário (auth + perfil)
  const handlecadastromembro = async (e) => {
    e.preventDefault();
    setloading(true);
    const fd = new FormData(e.target);
    
    const email = fd.get('email');
    const senha = fd.get('senha');
    const nome = fd.get('nome');
    const role = fd.get('role');

    // cria o acesso no sistema de autenticação
    const { data: authdata, error: autherror } = await supabase.auth.signup({
      email,
      password: senha,
    });

    if (autherror) {
      alert("erro ao criar acesso: " + autherror.message);
    } else {
      // insere os dados complementares na tabela de perfis
      const { error: perfilerror } = await supabase
        .from('perfis')
        .insert([{ id: authdata.user.id, nome, email, role }]);

      if (!perfilerror) {
        alert("novo membro da equipe cadastrado com sucesso!");
        carregarequipe();
        e.target.reset();
      }
    }
    setloading(false);
  };

  // 3. função para remover membro (somente admin)
  const handleremovermembro = async (id, nome) => {
    if (window.confirm(`tem certeza que deseja remover ${nome} da equipe? o acesso continuará no banco mas o perfil será desativado.`)) {
      const { error } = await supabase
        .from('perfis')
        .delete()
        .eq('id', id);

      if (!error) {
        alert("membro removido!");
        carregarequipe();
      }
    }
  };

  // 4. função para alternar nível de acesso
  const handleAlternarRole = async (id, roleAtual) => {
    const novoRole = roleAtual === 'admin' ? 'operador' : 'admin';
    const { error } = await supabase
      .from('perfis')
      .update({ role: novoRole })
      .eq('id', id);

    if (!error) {
      carregarequipe();
    } else {
      alert("Erro ao alterar nível: " + error.message);
    }
  };

  return (
    <div className="max-w-5xl mx-auto space-y-8">
      {/* formulário de novo usuário */}
      <div className="bg-white p-6 md:p-8 rounded-3xl shadow-lg border border-gray-100">
        <header className="border-b pb-4 mb-6">
          <h2 className="text-2xl font-black text-blue-900 uppercase tracking-tight">👥 gerenciar equipe</h2>
          <p className="text-xs text-gray-500 font-bold uppercase">cadastro de operadores e administradores</p>
        </header>

        <form onSubmit={handlecadastromembro} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="md:col-span-2">
            <label className="text-[10px] font-black text-gray-400 uppercase ml-1">nome completo</label>
            <input name="nome" className="input-field" required placeholder="ex: joão da silva" />
          </div>

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase ml-1">e-mail institucional</label>
            <input name="email" type="email" className="input-field" required placeholder="email@mirassol.sp.gov.br" />
          </div>

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase ml-1">nível de acesso</label>
            <select name="role" className="input-field" required>
              <option value="operador">operador (apenas registro)</option>
              <option value="admin">administrador (acesso total)</option>
            </select>
          </div>

          <div className="md:col-span-2">
            <label className="text-[10px] font-black text-gray-400 uppercase ml-1">senha de primeiro acesso</label>
            <input name="senha" type="password" className="input-field" required placeholder="mínimo 6 caracteres" />
          </div>

          <button 
            disabled={loading}
            className="md:col-span-2 bg-blue-700 hover:bg-blue-800 text-white font-black py-4 rounded-2xl shadow-xl transition-all active:scale-95"
          >
            {loading ? "cadastrando..." : "cadastrar membro na equipe"}
          </button>
        </form>
      </div>

      {/* listagem de membros */}
      <div className="bg-white rounded-3xl shadow-lg overflow-hidden border border-gray-100">
        <div className="p-4 bg-gray-50 border-b font-bold text-xs uppercase text-gray-400 tracking-widest">
          membros ativos no sistema
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="text-[10px] uppercase text-gray-400 border-b">
                <th className="p-4">nome</th>
                <th className="p-4">e-mail</th>
                <th className="p-4 text-center">nível</th>
                <th className="p-4 text-right">ações</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {membros.map((m) => (
                <tr key={m.id} className="hover:bg-gray-50 transition-colors">
                  <td className="p-4 font-bold text-blue-900 text-sm">{m.nome}</td>
                  <td className="p-4 text-xs text-gray-500">{m.email}</td>
                  <td className="p-4 text-center">
                    <span className={`text-[9px] font-black px-3 py-1 rounded-full uppercase ${m.role === 'admin' ? 'bg-orange-100 text-orange-700' : 'bg-green-100 text-green-700'}`}>
                      {m.role}
                    </span>
                  </td>
                  <td className="p-4 text-right space-x-4">
                    <button 
                      onClick={() => handleAlternarRole(m.id, m.role)}
                      className="text-blue-600 hover:text-blue-800 font-black text-[10px] uppercase underline"
                    >
                      mudar nível
                    </button>
                    <button 
                      onClick={() => handleremovermembro(m.id, m.nome)}
                      className="text-red-600 hover:text-red-900 font-black text-[10px] uppercase underline"
                    >
                      remover
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
